import styled, { css } from "styled-components";

export const ClientSettingsMobileWrapperBox = styled.div<{ isOpen: boolean }>`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;

    display: grid;
    grid-template-rows: auto 1fr;

    background: ${props => props.theme.colors.backgroundMiddleDark};
    width: 100%;
    height: 100%;
    overflow-y: auto;
    transform: translateX(-100%);
    transition: transform 0.2s ease-in-out;

    ${props => props.isOpen && css`
        transform: translateX(0);
        z-index: 2;
    `}
`